<template>
  <v-container>
    <v-text-field label="メールアドレス" v-model='メールアドレス'></v-text-field>
    <v-text-field label="パスワード" v-model="パスワード" type='password'></v-text-field>

        <v-btn block @click='onClickログイン()'>ログイン</v-btn>
    <!-- <v-btn @click="onClickログアウト()">ログアウト</v-btn> -->
  </v-container>
</template>
<script>
export default {
  data(){
    return {
      メールアドレス:"",
      パスワード:"",
    }
  },

  mounted(){
    this.メールアドレス = this.$store.getters.account;
    this.パスワード = this.$store.getters.password;
  },

  methods:{
    onClickログイン(){
      if(this.メールアドレス=="masashi012@gmail.com"&&this.パスワード=="Slayers1"){
        let account = this.メールアドレス;
        let password = this.パスワード;

        this.$store.commit("login",{account,password});
        this.$router.push({
          path:"/admin/editnews",
        });
      }else{
        alert("パスワードが違います")
      }
    },

  }
}
</script>